import React from 'react';
import { PageContent } from '../../containers';
// import { useParams } from 'react-router-dom';

const ErrorPage = () => {
  return (
    <PageContent
      pageName='Error'
      pageKey='error'
    >
      Error Page!
    </PageContent>
  );
}

export default ErrorPage;
